import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon, Typography } from '@mui/material';

import { TripTypeEnum } from '@mopla/data-models';
import WalkingFilled from '@mopla/ui/icons/WalkingFilled.svg';

import { WalkIndicatorContainer } from './styled';
import { TWalkMode } from './types';

interface IBookingRouteWalkIndicatorProps {
	durationMinutes?: number;
	distanceMeters?: number;
	mode: TWalkMode;
}

export const BookingRouteWalkIndicator: FC<IBookingRouteWalkIndicatorProps> = ({
	durationMinutes,
	distanceMeters,
	mode,
}) => {
	const { t } = useTranslation('booking');

	const getText = () => {
		if (mode === TripTypeEnum.WALK) {
			return t('summary.route.walk_info', {
				minutes: durationMinutes,
				meters: distanceMeters,
			});
		}
		return t('summary.route.change');
	};

	return (
		<WalkIndicatorContainer>
			<SvgIcon component={WalkingFilled} inheritViewBox sx={{ fontSize: 18 }} />
			<Typography variant="b2">{getText()}</Typography>
		</WalkIndicatorContainer>
	);
};
